module.exports = __webpack_public_path__ + "img/majestic_logo.10dcfb30.jpg";